import { SourceType } from 'graphql-query-contracts';

export const SourceTypeLabel: Record<SourceType, string> = {
  [SourceType.SourceTypeActivate]: 'Activate',
  [SourceType.SourceTypeCbre]: 'CBRE',
  [SourceType.SourceTypeEntrata]: 'Entrata',
  [SourceType.SourceTypeMri]: 'MRI',
  [SourceType.SourceTypeRealPage]: 'RealPage',
  [SourceType.SourceTypeSfdc]: 'SFDC',
  [SourceType.SourceTypeVcm]: 'VCM',
  [SourceType.SourceTypeYardi]: 'Yardi',
  [SourceType.SourceTypeInvalid]: 'Invalid',
  [SourceType.Unrecognized]: 'Unrecognized',
};
